import { Resource } from "../resource/resource.model";

export class ContactDetailsHistory extends Resource {
    emailAddress: string;
    coreContactFieldId: string;
    value: string;
    formId: string;
    pageId: string;
    tenantId: string;
    dateCreated: Date;
}
